import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { APICallService } from 'src/app/services/api-call.service';
import { AppMessageService } from 'src/app/services/app-message.service';
import { JsonDataService } from 'src/app/services/json-data.service';
import { SecurityService } from 'src/app/services/security.service';
import { UserDetailsService } from 'src/app/services/user-details.service';
import { ProjectLovComponent } from '../project-lov/project-lov.component';

@Component({
  selector: 'class-lov',
  templateUrl: './class-lov.component.html',
  styleUrls: ['./class-lov.component.css']
})
export class ClassLovComponent implements OnInit {

  private classModuleId: string = 'BMM178';
  private selectedData: any;
  public titleLov: string = "Class".toUpperCase();

  classTable: any = {
    cols: [],
    tblData: [],
    selection: "single",
    paginator: true,
    rowsPerPage: 10,
    lazy: false,
    totalRecords: 15,
    loading: false,
  };

  private classTableNameCol: any[] = [
    {
      key: "CLASS_CD",
      header: "Code",
      dataType: "string"
    },
    {
      key: "CLASS_NAME",
      header: "Class Name",
      dataType: "string"
    },
  ];

  private classTableDescCol: any[] = [
    {
      key: "CLASS_CD",
      header: "Code",
      dataType: "string"
    },
    {
      key: "CLASS_DESC",
      header: "Class Description",
      dataType: "string"
    },
  ];

  private classTableCodeCol: any[] = [
    {
      key: "CLASS_CD",
      header: "Code",
      dataType: "string"
    },
    {
      key: "CLASS_DESC",
      header: "Class Code",
      dataType: "string"
    },
  ];

  constructor(
    private jsonDataService: JsonDataService,
    private dialogRef: MatDialogRef<ProjectLovComponent>,
    private _api: APICallService,
    private securityService: SecurityService,
    private appMessageService: AppMessageService,
    private userDetailService: UserDetailsService,
    @Inject(MAT_DIALOG_DATA) public fromMainData: any,
  ) {
    if("title" in this.fromMainData){
      this.titleLov = this.fromMainData.title;
    }
    if(this.fromMainData.col === 'DESC'){
      this.classTable.cols = this.classTableDescCol;
    }
    else if(this.fromMainData.col === 'CODE'){
      this.classTable.cols = this.classTableCodeCol;
    }
    else{
      this.classTable.cols = this.classTableNameCol;
    } 
    // this.classTable.cols = (this.fromMainData.col === 'DESC') ? this.classTableDescCol : this.classTableNameCol;
    this.getClassData();
  }

  ngOnInit(): void {
  }

  onRowClick(ev: any) {
    try {
      this.selectedData = ev;
    } catch (e) {
    console.error(e);

    }
  }

  private getClassData(): void {
    try {
      this.classTable.loading = true;
      this.jsonDataService.contorlLoading(true);
      this._api.getClassCd({
        lineCd: this.fromMainData.lineCd,
        moduleId: this.fromMainData.moduleId,
        userId: this.userDetailService.userId,
        type: "LOV"
      }).subscribe({
        next: (response: any) => {
          this.securityService.checkRequestKeyResponse(response, () => {
            this.securityService.hasValidCsrfToken(response, () => {
              let content = JSON.parse(this.jsonDataService.decrypt(response.response));
              if (content.moduleId === this.classModuleId) {
                this.jsonDataService.contorlLoading(false);
                this.classTable.tblData = content.data.filter((e: any) => e.ACTIVE_TAG == 'A');
                this.classTable.loading = false;
              } else {
                this.classTable.loading = false;
                this.jsonDataService.contorlLoading(false);
                this.appMessageService.showAppMessage("You do not have the correct privilege to access the data. Kindly contact your administrator for assistance.", "error");
              }
            });
          });
        },
        error: (e: any) => {
          this.securityService.checkRequestKeyResponse(e, () => {

            this.classTable.loading = false;
            this.jsonDataService.contorlLoading(false);
            this.appMessageService.showAppMessage(e, "error");
          });
        }
      });
    }
    catch (e) {
    console.error(e);

      this.classTable.loading = false;
      this.jsonDataService.contorlLoading(false);
    }
  }

  onClose(str: string) {
    try {
      if (this.selectedData == '' || this.selectedData == null) {
        this.dialogRef.close({ content: '', button: str });
      }
      else {
        this.dialogRef.close({ content: this.selectedData, button: str });
      }
    } catch (e) {
    console.error(e);

    }
  }

}
